import { faChevronLeft } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonUIColor, ModalHeader, Typography } from "@joonapp/web-shared"
import dayjs from "dayjs"

import { getCurrentAge } from "../../../util/dates"
import useSurveysModalStore from "../store/useSurveysModalStore"

const Survey = () => {
  const { selectedSurvey, selectedProfile, onClose, clearSurvey } =
    useSurveysModalStore()

  if (!selectedSurvey || !selectedProfile) return null

  return (
    <>
      <ModalHeader
        onClose={onClose}
        title={
          (
            <div className="flex flex-row gap-3 items-center">
              <button onClick={clearSurvey}>
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  color={JoonUIColor.icon.neutral}
                  fontSize={16}
                />
              </button>
              <Typography variant="h4">Survey details</Typography>
            </div>
          ) as any
        }
        showBorderBottom
      />
      <div className="flex flex-col px-6 py-4 bg-bgXLightGray border-b border-borderPrimary">
        <Typography variant="bodySmall">
          {selectedProfile?.user.name}{" "}
          {"birthdate" in selectedProfile?.user &&
            selectedProfile?.user.birthdate &&
            `(${getCurrentAge(selectedProfile?.user.birthdate)})`}
        </Typography>
        <div className="flex flex-row  justify-between items-center flex-wrap">
          <Typography variant="bodyBold">
            {selectedSurvey.questionnaire.display_name}
          </Typography>
          <Typography variant="bodyXSmall" color={JoonUIColor.text.secondary}>
            Completed on{" "}
            {dayjs(selectedSurvey.date_submitted).format("MMM D, YYYY")}
          </Typography>
        </div>
      </div>
      <div className="flex flex-col gap-4 p-6 pt-4 overflow-y-auto">
        {selectedSurvey.answers.map((answer, index) => (
          <div key={index} className="flex flex-col gap-1">
            <Typography variant="body">{answer.question.question}</Typography>
            {answer.answers.length > 0 ? (
              answer.answers.map((answer) => (
                <div className="p-3 bg-bgLightGray rounded-md border border-borderPrimary">
                  <Typography variant="bodySmall">{answer.answer}</Typography>
                </div>
              ))
            ) : answer.freeform_answer ? (
              <div className="p-3 bg-bgLightGray rounded-md border border-borderPrimary">
                <Typography variant="bodySmall">
                  {answer.freeform_answer}
                </Typography>
              </div>
            ) : (
              <div className="p-3 bg-bgLightGray rounded-md border border-borderPrimary">
                <Typography variant="bodySmall">No answer</Typography>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  )
}

export default Survey
